import { getPathString } from '@helpers'
import { EXPAND_FIELD_PREFIX } from '@constants'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

export const getObjectXLinkToObjectYKey = (linkToObjectY: EmbeddedObject[]) => {
  if (linkToObjectY.length > 1) {
    return `${getPathString(linkToObjectY.slice(0, -1), EXPAND_FIELD_PREFIX)}.${
      linkToObjectY[linkToObjectY.length - 1].field
    }`
  }

  return getPathString(linkToObjectY)
}
